export enum FieldType {
  Input = 'INPUT',
  TextArea = 'TEXTAREA',
  Dropdown = 'DROPDOWN',
  Checkbox = 'CHECKBOX',
  Toggle = "TOGGLE",
  Radio = 'RADIO',
  File = 'FILE',
  Date = "DATE",
  Custom = 'CUSTOM',

  // For utils only
  Head = 'HEAD',
  Separator = 'SEPARATOR',
}
